import { EnvironmentFilled } from "@ant-design/icons"
import { Button, type ButtonProps } from "components/Button/Button"
import { MouseEventHandler } from "react"
import { cn } from "styles/cn"
import { DEFAULT_PLACEHOLDER } from "utils/constants"

export function AddressLink({ children, className, ...props }: ButtonProps) {
	const handleClick: MouseEventHandler<HTMLButtonElement> = (e) => {
		e.stopPropagation()

		if (!children || typeof children !== "string") return

		const encodedAddress = encodeURIComponent(children)
		const mapsUrl = /Mac|iPhone|iPad|iPod/.test(navigator.userAgent)
			? `https://maps.apple.com/?q=${encodedAddress}`
			: `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`

		window.open(mapsUrl, "_blank", "noopener,noreferrer")
	}

	if (!children) return DEFAULT_PLACEHOLDER

	return (
		<Button
			{...props}
			type="link"
			icon={<EnvironmentFilled />}
			aria-label={`Open address ${children as string}`}
			className={cn(
				"h-fit min-w-0 justify-start px-0 [&>*:last-child]:truncate",
				className,
			)}
			onClick={handleClick}
			onKeyDown={(e) => e.stopPropagation()}
		>
			{children}
		</Button>
	)
}
